<template>
  <div class="gene-panel-quick-selection-dailog dialog col-block">
    <div class="title-container row-block">
      <template v-if="curDivision">
        <img :src="require('../../assets/images/gene-panel-selection-return-icon.svg')" alt="" @click="e => curDivision = null">
        <div :style="{ width: '10px' }"></div>
      </template>
      <div class="title">{{ curDivision || $t('DIALOG.genePanelQuickSelection.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container row-block flex-wrap flex-start" :style="{ flex: 1, 'max-height': Math.min(windowHeight - 321, curDivision ? 630 : 530) + 'px' }">
      <template v-if="!curDivision">
        <div class="data-block" :style="{ width: '33.33333%' }" v-for="(division, index) in sortData(divisions, data => data)" :key="index">
          <div class="data division row-block" @click="e => curDivision = division">
            <div class="division-icon center-block">
              <img :src="require('../../assets/divisionIcons/' + division + '.svg')" alt="">
            </div>
            <div :style="{ width: '20px' }"></div>
            <div class="division-info col-block" :style="{ flex: 1, width: 0 }">
              <div class="division-title ellipsis" :title="division">{{ division }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="division-content">{{ $t('DIALOG.genePanelQuickSelection.block.content.___division') + ': ' + toPriceString(genePanels[division].length) }}</div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="data-block" :style="{ width: '33.33333%' }" v-for="(panel, index) in sortData(genePanels[curDivision], data => data.name)" :key="index">
          <div class="data panel col-block" @click="e => $emit('changeModal', {}, panel.id)">
            <div class="panel-title ellipsis">{{ panel.name }}</div>
            <div :style="{ height: '2px' }"></div>
            <div class="panel-sub"><b v-if="false" class="main">{{ '(' + $t('DIALOG.genePanelQuickSelection.block.subtitle.___panel01') + ') ' }}</b>{{ $t('DIALOG.genePanelQuickSelection.block.subtitle.___panel02') + ': ' }}<b>{{ panel.count }}</b></div>
            <div :style="{ height: '5px' }"></div>
            <div class="panel-content" :style="{ flex: 1 }">{{ panel.note ? panel.note.length > 100 ? panel.note.slice(0, 100) + '...' : panel.note : '' }}</div>
          </div>
        </div>
      </template>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import responsitive from '../../mixins/responsitive'
import { toPriceString, sortData } from '../../constants/global/util'

export default {
  mixins: [
    responsitive
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      curDivision: null
    }
  },
  computed: {
    genePanels () {
      let genePanels = this.param.divisions.reduce((s, c) => ({ ...s, [c]: [] }), {})
      this.datas.forEach(data => {
        let count = data.count || [
          (data.data['free_typing'] || []).length,
          (data.data['user_defined'] || []).length,
          (data.data['panel'] || []).reduce((s, panelData) => s + panelData.data.length, 0),
          (data.data['hpo'] || []).reduce((s, panelData) => s + panelData.data.length, 0),
          (data.data['condition'] || []).reduce((s, panelData) => s + panelData.data.length, 0)
        ].reduce((s, c) => s + c, 0)
        genePanels[data.division] && genePanels[data.division].push({
          ...data,
          count: count
        })
      })
      return genePanels
    },
    // param
    datas () {
      return this.param.datas
    },
    divisions () {
      return this.param.divisions
    },
    // global
    toPriceString () { return toPriceString },
    sortData () { return sortData }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/genePanelQuickSelection.vue